import React, { useState } from "react";
import API_BASE_URL from "../../config";
import "./SendSOAModal.css";

function SendSOAModal({ client = null, lead = null, onClose }) {
  const record = lead || client;
  const recordType = lead?.id ? "lead" : "client";

  const [sendMethod, setSendMethod] = useState("email");
  const [customDestination, setCustomDestination] = useState("");
  const [sendSpanish, setSendSpanish] = useState(false);

  const productOptions = [
    {
      key: "mapd",
      label: "Medicare Advantage Plans (Part C) and Cost Plans",
    },
    {
      key: "pdp",
      label: "Stand-alone Medicare Prescription Drug Plans (Part D)",
    },
    {
      key: "medsupp",
      label: "Medicare Supplement (Medigap) Products",
    },
    {
      key: "dental",
      label: "Dental / Vision / Hearing Products",
    },
    {
      key: "hospital",
      label: "Hospital Indemnity Products",
    },
  ];

  const [products, setProducts] = useState({
    mapd: false,
    pdp: false,
    medsupp: false,
    dental: false,
    hospital: false,
  });

  const toggleProduct = (key) => {
    setProducts((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const hasSelectedProduct = Object.values(products).some(Boolean);

  const handleSend = async () => {
    if (!record?.id) {
      alert("No lead or client record found for this SOA.");
      return;
    }

    if (!hasSelectedProduct) {
      alert("Please select at least one product to discuss.");
      return;
    }

    const token = localStorage.getItem("token");

    let destination = "";

    if (sendMethod === "email") destination = record.email || "";
    if (sendMethod === "text") destination = record.phone || "";
    if (sendMethod === "custom") destination = customDestination.trim();

    if (!destination) {
      alert("Please enter or select a destination.");
      return;
    }

    const payload = {
      lead_id: recordType === "lead" ? record.id : null,
      client_id: recordType === "client" ? record.id : null,
      send_method: sendMethod === "custom" ? "email" : sendMethod,
      destination,
      products,
      spanish: sendSpanish,
    };

    try {
      const res = await fetch(`${API_BASE_URL}/api/soa/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) {
        console.error("SOA send error:", data);
        alert(data?.message || "Failed to send SOA.");
        return;
      }

      alert("SOA sent successfully.");
      onClose();
    } catch (err) {
      console.error("SOA send error:", err);
      alert("Error sending SOA.");
    }
  };

  return (
    <div className="soa-modal-backdrop">
      <div className="soa-modal">
        <div className="soa-modal-header">
          <div className="soa-modal-title">Send Scope Of Appointment</div>

          <button className="soa-modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="soa-send-box">
          <p className="soa-instruction">
            Please select where you would like to send the SOA:
          </p>

          <div className="soa-option-row">
            <input
              type="radio"
              checked={sendMethod === "email"}
              onChange={() => setSendMethod("email")}
            />
            <div>
              <strong>Email:</strong> {record?.email || "No email available"}
            </div>
          </div>

          <div className="soa-option-row">
            <input
              type="radio"
              checked={sendMethod === "text"}
              onChange={() => setSendMethod("text")}
            />
            <div>
              <strong>Text:</strong> {record?.phone || "No phone available"}
            </div>
          </div>

          <div className="soa-option-row">
            <input
              type="radio"
              checked={sendMethod === "custom"}
              onChange={() => setSendMethod("custom")}
            />
            <div>New Email Or Mobile Number</div>
          </div>

          {sendMethod === "custom" && (
            <input
              className="soa-destination-input"
              type="text"
              placeholder="Enter email or mobile number"
              value={customDestination}
              onChange={(e) => setCustomDestination(e.target.value)}
            />
          )}

          <hr className="soa-divider" />

          <h4 className="soa-section-title">Plans to Discuss</h4>

          <div className="soa-products">
            {productOptions.map((product) => (
              <div key={product.key} className="soa-product-row">
                <input
                  type="checkbox"
                  checked={products[product.key]}
                  onChange={() => toggleProduct(product.key)}
                />
                <div>{product.label}</div>
              </div>
            ))}
          </div>

          <hr className="soa-divider" />

          <div className="soa-product-row">
            <input
              type="checkbox"
              checked={sendSpanish}
              onChange={() => setSendSpanish(!sendSpanish)}
            />
            <div>Send in Spanish</div>
          </div>
        </div>

        <div className="soa-modal-footer">
          <button className="soa-cancel-btn" onClick={onClose}>
            Cancel
          </button>

          <button className="soa-send-btn" onClick={handleSend}>
            Send SOA →
          </button>
        </div>
      </div>
    </div>
  );
}

export default SendSOAModal;